import { REHYDRATE } from 'redux-persist/constants'
import { GET_SESSION, START_CALL, STOP_CALL } from './constants'

const initialState = {
  sessionId: null,
  startTime: null,
  appId: null
}

export default function callControlReducer(state = initialState, action) {
  switch (action.type) {
    case START_CALL.REQUEST: {
      return {
        ...state
      }
    }
    case START_CALL.SUCCESS: {
      return {
        ...state,
        sessionId: action.data.engagementID,
        startTime: action.data.startTime,
        appId: action.data.appID
      }
    }

    case STOP_CALL.SUCCESS: {
      return {
        ...state,
        startTime: null,
        sessionId: null,
        appId: null
      }
    }

    case GET_SESSION.REQUEST: {
      return {
        ...state
      }
    }
    case GET_SESSION.SUCCESS: {
      return {
        ...state,
        startTime: action.data.startTime,
        sessionId: action.data.engagementID,
        appId: action.data.appID
      }
    }

    case REHYDRATE: {
      return {
        ...state,
        ...action.payload.callControl
      }
    }

    default: {
      return state
    }
  }
}
